import { render } from "./SceneView.vue?vue&type=template&id=59ef8996&scoped=true&ts=true"
import script from "./SceneView.vue?vue&type=script&lang=ts"
export * from "./SceneView.vue?vue&type=script&lang=ts"

import "./SceneView.vue?vue&type=style&index=0&id=59ef8996&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ef8996"]])

export default __exports__